import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 1:
    case 3:
    case 7:
    case 9:
    case 11:
    case 13:
    case 15:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    case 5:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#ff41be',
        i18nKey: 'playAlt',
        splat: 'right',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 19:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#ff41be',
        i18nKey: 'playAlt',
        splat: 'left',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 20:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.SOLUTION,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
